import { useRecordContext } from 'react-admin'
import {
  Box,
  CardHeader,
  List as ListMui,
  ListItem,
  ListItemText,
  Paper,
} from '@material-ui/core'

export const InfosComplementary = (props) => {
  const record = useRecordContext(props)
  if (!record) return null
  return (
    <Box component={Paper}>
      <CardHeader title="Informations complémentaires" />
      <ListMui>
        <ListItem>
          <ListItemText
            primary="Societe Interphone"
            secondary={record.fiche_interphones || 'Non applicable'}
          />
        </ListItem>
        <ListItem>
          <ListItemText
            primary="Societe Badge"
            secondary={record.fiche_vigik || 'Non applicable'}
          />
        </ListItem>
      </ListMui>
    </Box>
  )
}
